module.exports = __webpack_public_path__ + "img/MTABAPPDBP.b79dcb3b.jpg";